/**
 * Non-Twire code
 * 
 * Any code that doesn't relate to that which comes with TWire
 * 
 * NOTE: Not running twire-app.js; it's all in here due to Swup
 */
import './easing';
import lynxCore    from './lynx-core';
import lynxPayment from './lynx-payment';


'use strict';


/**
 * Determine input type
 */
var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
$('body').attr('data-input', isTouchDevice ? 'touch' : 'indirect');


/**
 * Global cursor
 */
let mX = 0, mY = 0, bX = 0, bY = 0;

$(window).on('mousemove', e => { 
	
	mX = e.clientX; 
	mY = e.clientY; 



});

gsap.ticker.add(() => {

	bX += (mX - bX) * 0.1; bY += (mY - bY) * 0.1;

	gsap.set('div.global-cursor', { 
		
		x: bX, 
		y: bY 
	
	});

});

$(window).on('mousedown', function() {

    gsap.to('div.global-cursor', {

        scale: 2.5, 
        opacity: 0, 
        duration: 0.5,
        ease: 'power2.out',
        onComplete: () => {

            gsap.set('div.global-cursor', { 
				
				scale: 1, 
				opacity: 1 
			
			});

        }

    });

});


/**
 * Swup
 */
const swup = new Swup({

	cache: false, // Seemed to be caching things changed in the CMS
	linkSelector: 'a[href], svg a[*|href]',
	animationSelector: false,
	ignoreVisit: (url, { el }) => {

		const href = el?.getAttribute('href');

		// Ignore any link that starts with #
		if (href && href.startsWith('#')) {

			return true;

		}

		return false;

	}

});

swup.hooks.on('visit:start', async () => {

	$('div.global-page-loader div.pulse').fadeIn();

	await gsap.to('div.global-page-loader', { 
		
		left: 0, 
		duration: 0.8, 
		ease: 'power4.inOut' 
	
	});

	// Delay for testing
	//await new Promise(r => setTimeout(r, 1500));

});

swup.hooks.on('content:replace', (visit) => {

	// Loader
	gsap.timeline()
		.to('div.global-page-loader', { left: '100%', duration: 0.8, ease: 'power4.inOut' })
		.set('div.global-page-loader', { left: '-100%' });

	// Copy body classes so CSS works
	const newClasses = visit.to.document.body.className;
    document.body.className = newClasses;

});

initLynx();

swup.hooks.on('page:view', () => initLynx());


/**
 * Wrap everything in a function so that Swup can use it
 */
function initLynx() {

	var $window		= $(window);
	var $document 	= $(document);
	var $body 		= $('body');

	// TODO Review this list

	// 1. Kill jQuery Listeners (Namespace surgical strike)
	$window.off('.twire .lynx');
	$document.off('.twire .lynx');

	// 2. Kill GSAP ScrollTriggers (The "Nuclear" option)
	// This stops trackers and removes pin-spacers
	if (typeof ScrollTrigger !== 'undefined') {

		ScrollTrigger.getAll().forEach(t => t.kill());

	}

	// 3. Kill Draggables (Targeting by class)
	// Using .get() with the class name finds all instances across all files
	if (typeof Draggable !== 'undefined') {

		const draggables = Draggable.get('.carousel-circle');

		if (Array.isArray(draggables)) {

			draggables.forEach(d => d.kill());

		} else if (draggables) {
			
			draggables.kill();
	
		}

	}


	// Core
	lynxCore();


	/////////////////
	// Page-specific:
	/////////////////


	// Circle carousels
	function initCarousel() {

	    $('main div.carousel-circle-parent').each(function() {

	        const slides = gsap.utils.toArray('div.carousel-circle-slide');
	        const track = document.querySelector('div.carousel-circle');

	        function updateCarousel() {

	            const centerX = window.innerWidth / 2;
	            const isMobile = window.innerWidth < 1150; // $smallTabletBreakpoint


	            slides.forEach(slide => {

	                const rect = slide.getBoundingClientRect();
	                const slideCenter = rect.left + (rect.width / 2);
	                const normDist = (slideCenter - centerX) / (window.innerWidth / 1.5);

	                if (isMobile) {

	                    gsap.set(slide, {

	                        rotation: 0,
	                        y: 0,
	                        scale: 1, // Keep them uniform on mobile
	                        overwrite: true
	                        
	                    });

	                } else {

	                    gsap.set(slide, {

	                        rotation: normDist * 15,
	                        y: Math.pow(Math.abs(normDist), 2) * 180,
	                        overwrite: true

	                    });

	                }

	            });
	            
	        }

	        Draggable.get(track)?.kill();

	        Draggable.create(track, {

	            type: 'x',
	            dragClickables: true,
	            bounds: {

	                minX: -track.clientWidth + window.innerWidth * 0.7, 
	                maxX: window.innerWidth * 0.3 

	            },
	            onDrag: updateCarousel,
	            // Since you don't have InertiaPlugin, we use onDragEnd
	            onDragEnd: function() {

	                const centerX = window.innerWidth / 2;
	                let closestSlide = slides[0];
	                let minDistance = Infinity;

	                // 1. Find the slide closest to the center
	                slides.forEach(slide => {

	                    const rect = slide.getBoundingClientRect();
	                    const slideCenter = rect.left + (rect.width / 2);
	                    const distance = Math.abs(centerX - slideCenter);
	                    
	                    if (distance < minDistance) {

	                        minDistance = distance;
	                        closestSlide = slide;

	                    }

	                });


	                // 2. Calculate how much we need to move the TRACK 
	                // to put that slide exactly in the center
	                const rect = closestSlide.getBoundingClientRect();
	                const slideCenter = rect.left + (rect.width / 2);
	                const diff = centerX - slideCenter;
	                const targetX = this.x + diff;

	                // 3. Smoothly animate to the center
	                gsap.to(track, {

	                    x: targetX,
	                    duration: 0.6,
	                    ease: "power3.out",
	                    onUpdate: updateCarousel // Keeps the rotation/Y curve updating during snap

	                });

	            }

	        });

	        function moveCarousel(direction) {

	            const $track = $('div.carousel-circle');
	            const $items = $('div.carousel-circle-slide');
	            const centerX = window.innerWidth / 2;
	            
	            let closestIndex = 0;
	            let minDistance = Infinity;

	            // 1. Find the index of the slide currently closest to the center
	            $items.each(function(i) {

	                const rect = this.getBoundingClientRect();
	                const slideCenter = rect.left + (rect.width / 2);
	                const dist = Math.abs(centerX - slideCenter);

	                if (dist < minDistance) {

	                    minDistance = dist;
	                    closestIndex = i;

	                }
	            });

	            // 2. Determine the target index (clamped between 0 and 5)
	            let targetIndex = closestIndex + direction;
	            targetIndex = gsap.utils.clamp(0, $items.length - 1, targetIndex);

	            // 3. Calculate exactly where the track needs to be to center THAT index
	            // We get the position of the target slide relative to the track
	            const targetSlide = $items.eq(targetIndex);
	            const trackX = gsap.getProperty($track[0], 'x');
	            const slideRect = targetSlide[0].getBoundingClientRect();
	            const slideCenter = slideRect.left + (slideRect.width / 2);
	            
	            // The difference between where the slide is and where the center is
	            const diff = centerX - slideCenter;
	            const finalX = trackX + diff;

	            // 4. Animate to the specific slide
	            gsap.to($track, {

	                x: finalX,
	                duration: 0.7,
	                ease: 'power3.out',
	                onUpdate: updateCarousel // Keeps your Y-dip and rotation active

	            });
	            
	        }

	        $('a.carousel-circle-nav-arrow.next').off('click').on('click', () => moveCarousel(1));
	        $('a.carousel-circle-nav-arrow.prev').off('click').on('click', () => moveCarousel(-1));

			if ($body.data('input') == 'touch') {

		        $('div.carousel-circle-slide').off('click').on('click', function() {

		            $(this).toggleClass('active');

		        })

			} else {

				$('div.carousel-circle-slide').off('click').on('mouseenter', function() {

			        $(this).addClass('active');

			    }).on('mouseleave', function() {

			        $(this).removeClass('active');
					
			    });

			}

	        updateCarousel();

	    });

	}

	initCarousel();

	let resizeTimer;

	$window.on('resize.twire', function() {

	    clearTimeout(resizeTimer);
	    resizeTimer = setTimeout(initCarousel, 250);

	});


	// Home fAQ slides
	if ($body.hasClass('home') === true) {

		let mm = gsap.matchMedia();

		mm.add('(min-width: 950px) and (min-height: 550px)', () => {

			const items = gsap.utils.toArray('div.panel-item');

			let tl = gsap.timeline({

				scrollTrigger: {

					trigger: 'div.panel-container',
					start: 'top top',
					end: '+=4000',
					scrub: 1,
					pin: true

				}

			});

			items.forEach((item, i) => {

				const title = item.querySelector('h2.panel-title');
				const content = item.querySelector('div.panel-content');

				tl.to(title, { opacity: 1, duration: 1 })
				  .to(content, { height: 'auto', duration: 1 }, '<')
				  .addLabel('f-' + i).to({}, { duration: 3 });

				if (i < items.length - 1) {

					tl.to(title, { opacity: 1, duration: 1 }).to(content, { height: 0, duration: 1 }, '<');

				}

			});

			$('div.panel-item').off('click').on('click', function () {

				const idx = $(this).attr("data-index");
				const st = tl.scrollTrigger;
				const pos = st.start + (st.end - st.start) * (tl.labels['f-' + idx] / tl.duration());
				gsap.to(window, { scrollTo: pos, duration: 1.2 });

			});

		});

	}


	// Payment
	if ($body.hasClass('book-now') === true) {

		lynxPayment();

	}


	// About
	if ($body.hasClass('about') === true) {

		gsap.registerPlugin(ScrollTrigger);

		let mm = gsap.matchMedia();

		mm.add('(min-width: 1151px) and (max-aspect-ratio: 1.8/1)', () => { // sync with .scss

		    const slides = gsap.utils.toArray('div.about-slide');
		    
		    // 1. Setup initial state
		    // We move them 100vh down (completely off the bottom of the screen)
		    // and assign z-index based on order so they stack correctly.
		    slides.forEach((slide, i) => {

		        gsap.set(slide, { 

		            y: '90vh', 
		            zIndex: i 
		        });

		    });

		    // The first slide should be in its final "resting" position immediately
		    gsap.set(slides[0], { y: 0 });

		    const tl = gsap.timeline({

		        scrollTrigger: {

		            trigger: 'div.different',
		            start: 'top top',
		            end: () => '+=' + (slides.length * 100) + '%',
		            pin: true,
		            scrub: true,
		        }

		    });

		    // 2. Animate subsequent slides one by one
		    slides.forEach((slide, i) => {

		        if (i === 0) return;

		        tl.to(slide, {

		            // This is the 'resting' position
		            // i * 40 pushes it down slightly to show the stack above it
		            y: i * 40, 
		            ease: 'none'

		        }, i); // Position parameter ensures sequential entry
		    });

		});

	}


	// Triggers
	$window.trigger('scroll');
	$window.trigger('resize');

}